// eslint-disable-next-line canonical/filename-match-regex
export enum IsoCountryCode2Alpha {
    AD = 'Andorra',
    AE = 'Vereinigte Arabische Emirate',
    AF = 'Afghanistan',
    AG = 'Antigua und Barbuda',
    AI = 'Anguilla',
    AL = 'Albanien',
    AM = 'Armenien',
    AN = 'Niederländische Antillen',
    AO = 'Angola',
    AR = 'Argentinien',
    AT = 'Österreich',
    AU = 'Australien',
    AW = 'Aruba',
    AX = 'Åland',
    AZ = 'Aserbaidschan',
    BA = 'Bosnien und Herzegowina',
    BB = 'Barbados',
    BD = 'Bangladesch',
    BE = 'Belgien',
    BF = 'Burkina Faso',
    BG = 'Bulgarien',
    BH = 'Bahrain',
    BI = 'Burundi',
    BJ = 'Benin',
    BN = 'Brunei',
    BO = 'Bolivien',
    BR = 'Brasilien',
    BS = 'Bahamas',
    BT = 'Bhutan',
    BW = 'Botsuana',
    BY = 'Weißrussland',
    BZ = 'Belize',
    CA = 'Kanada',
    CD = 'Demokratische Republik Kongo',
    CF = 'Zentralafrikanische Republik',
    CG = 'Republik Kongo',
    CH = 'Schweiz',
    CI = 'Elfenbeinküste',
    CL = 'Chile',
    CM = 'Kamerun',
    CN = 'Republik China (Taiwan)',
    CO = 'Kolumbien',
    CR = 'Costa Rica',
    CU = 'Kuba',
    CV = 'Kap Verde',
    CY = 'Zypern',
    CZ = 'Tschechien',
    DE = 'Deutschland',
    DJ = 'Dschibuti',
    DK = 'Dänemark',
    DM = 'Dominica',
    DO = 'Dominikanische Republik',
    DZ = 'Algerien',
    EC = 'Ecuador',
    EE = 'Estland',
    EG = 'Ägypten',
    EH = 'Demokratische Arabische Republik Sahara',
    ER = 'Eritrea',
    ES = 'Spanien',
    ET = 'Äthiopien',
    FI = 'Finnland',
    FJ = 'Fidschi',
    FM = 'Mikronesien',
    FO = 'Färöer',
    FR = 'Frankreich',
    GA = 'Gabun',
    GB = 'Vereinigtes Königreich',
    GD = 'Grenada',
    GE = 'Georgien',
    GG = 'Guernsey',
    GH = 'Ghana',
    GI = 'Gibraltar',
    GL = 'Grönland',
    GM = 'Gambia',
    GN = 'Guinea',
    GQ = 'Äquatorialguinea',
    GR = 'Griechenland',
    GT = 'Guatemala',
    GW = 'Guinea-Bissau',
    GY = 'Guyana',
    HK = 'Hongkong',
    HN = 'Honduras',
    HR = 'Kroatien',
    HT = 'Haiti',
    HU = 'Ungarn',
    ID = 'Indonesien',
    IE = 'Irland',
    IL = 'Israel',
    IM = 'Insel Man',
    IN = 'Indien',
    IQ = 'Irak',
    IR = 'Iran',
    IS = 'Island',
    IT = 'Italien',
    JE = 'Jersey',
    JM = 'Jamaika',
    JO = 'Jordanien',
    JP = 'Japan',
    KE = 'Kenia',
    KG = 'Kirgisistan',
    KH = 'Kambodscha',
    KI = 'Kiribati',
    KM = 'Komoren',
    KN = 'St. Kitts und Nevis',
    KP = 'Nordkorea',
    KR = 'Südkorea',
    KW = 'Kuwait',
    KZ = 'Kasachstan',
    LA = 'Laos',
    LB = 'Libanon',
    LC = 'St. Lucia',
    LI = 'Liechtenstein',
    LK = 'Sri Lanka',
    LR = 'Liberia',
    LS = 'Lesotho',
    LT = 'Litauen',
    LU = 'Luxemburg',
    LV = 'Lettland',
    LY = 'Libyen',
    MA = 'Marokko',
    MC = 'Monaco',
    MD = 'Moldawien',
    ME = 'Montenegro',
    MG = 'Madagaskar',
    MH = 'Marshallinseln',
    MK = 'Mazedonien',
    ML = 'Mali',
    MM = 'Myanmar',
    MN = 'Mongolei',
    MR = 'Mauretanien',
    MT = 'Malta',
    MU = 'Mauritius',
    MV = 'Malediven',
    MW = 'Malawi',
    MX = 'Mexiko',
    MY = 'Malaysia',
    MZ = 'Mosambik',
    NA = 'Namibia',
    NC = 'Neukaledonien',
    NE = 'Niger',
    NG = 'Nigeria',
    NI = 'Nicaragua',
    NL = 'Niederlande',
    NO = 'Norwegen',
    NP = 'Nepal',
    NR = 'Nauru',
    NZ = 'Neuseeland',
    OM = 'Oman',
    PA = 'Panama',
    PE = 'Peru',
    PG = 'Papua-Neuguinea',
    PH = 'Philippinen',
    PK = 'Pakistan',
    PL = 'Polen',
    PR = 'Puerto Rico',
    PS = 'Palästinensische Autonomiegebiete',
    PT = 'Portugal',
    PW = 'Palau',
    PY = 'Paraguay',
    QA = 'Katar',
    RO = 'Rumänien',
    RS = 'Serbien',
    RU = 'Russland',
    RW = 'Ruanda',
    SA = 'Saudi-Arabien',
    SB = 'Salomonen',
    SC = 'Seychellen',
    SD = 'Sudan',
    SE = 'Schweden',
    SG = 'Singapur',
    SI = 'Slowenien',
    SK = 'Slowakei',
    SL = 'Sierra Leone',
    SM = 'San Marino',
    SN = 'Senegal',
    SO = 'Somalia',
    SR = 'Suriname',
    ST = 'São Tomé und Príncipe',
    SV = 'El Salvador',
    SY = 'Syrien',
    SZ = 'Swasiland',
    TD = 'Tschad',
    TG = 'Togo',
    TH = 'Thailand',
    TJ = 'Tadschikistan',
    TL = 'Osttimor',
    TM = 'Turkmenistan',
    TN = 'Tunesien',
    TO = 'Tonga',
    TR = 'Türkei',
    TT = 'Trinidad und Tobago',
    TV = 'Tuvalu',
    TZ = 'Tansania',
    UA = 'Ukraine',
    UG = 'Uganda',
    US = 'Vereinigte Staaten von Amerika',
    UY = 'Uruguay',
    UZ = 'Usbekistan',
    VA = 'Vatikanstaat',
    VC = 'St. Vincent und die Grenadinen',
    VE = 'Venezuela',
    VN = 'Vietnam',
    VU = 'Vanuatu',
    WS = 'Samoa',
    YE = 'Jemen',
    ZA = 'Südafrika',
    ZM = 'Sambia',
    ZW = 'Simbabwe',
}

export function getCountryByCountryCode(countryCode: keyof typeof IsoCountryCode2Alpha): string {
    // eslint-disable-next-line canonical/id-match
    return IsoCountryCode2Alpha[countryCode];
}
